export const TYPE_CONDITION = 'conditions'
export const TYPE_ACTION = 'actions'
export const ALERT_ICON = [
  { label: 'Warning', value: 'warning' },
  { label: 'Error', value: 'error' },
  { label: 'Success', value: 'success' },
  { label: 'Info', value: 'info' },
  { label: 'Question', value: 'question' },
]

export const CALL_API_MODE_OPTIONS = [
  { label: 'Wait', value: 'Wait' },
  { label: 'No Wait', value: 'Background' },
]

export const ONLY_FIXED = {
  checkboxGroup: {
    showOnlyFixed: false,
    condition: ['isAllOf', 'isAnyOf'],
  },
  button: {
    showOnlyFixed: true,
    condition: ['isOnClick', 'isActive', 'isShow', 'isAfterSuccess'],
  },
  list: {
    showOnlyFixed: true,
    condition: ['isOnClick', 'isActive', 'isShow'],
  },
  condition: {
    showOnlyFixed: true,
    condition: ['isCondition'],
  },
  provider: {
    showOnlyFixed: true,
    condition: ['isLocked'],
  },
  select: {
    showOnlyFixed: false,
    condition: ['isCompareOption'],
  },
  table: {
    showOnlyFixed: true,
    condition: [
      'isEmpty',
      'isFilled',
      'isSelectRow',
      'isUnSelectRow',
      'isAddRow',
      'isEditRow',
      'isAfterAddRow',
      'isAfterEditRow',
      'isAfterDeleteRow',
    ],
  },
  tabPanel: {
    showOnlyFixed: false,
    condition: ['isActiveTab'],
  },
  user: {
    showOnlyFixed: true,
    condition: ['isEqual', 'isNotEqual', 'isContained', 'isNotContained'],
  },
}

export const OPTIONS_CONDITION = [
  { label: 'IS EMPTY', value: 'isEmpty', showField: false },
  { label: 'IS FILLED', value: 'isFilled', showField: false },
  {
    label: 'IS EQUAL TO',
    value: 'isEqual',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS NOT EQUAL TO',
    value: 'isNotEqual',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS CONTAINED',
    value: 'isContained',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS NOT CONTAINED',
    value: 'isNotContained',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS ALL OF',
    value: 'isAllOf',
    showField: true,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS ANY OF',
    value: 'isAnyOf',
    showField: true,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS GREATER',
    value: 'isGreater',
    showField: true,
    showCompare: true,
  },
  { label: 'IS LESS', value: 'isLess', showField: true, showCompare: true },
  {
    label: 'IS GREATER OR EQUAL',
    value: 'isGreaterOrEqual',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS LESS OR EQUAL',
    value: 'isLessOrEqual',
    showField: true,
    showCompare: true,
  },
  {
    label: 'IS ON CLICK',
    value: 'isOnClick',
    showField: false,
    isActionOnClick: true,
  },
  {
    label: 'IS ON CHANGE',
    value: 'isOnChange',
    showField: false,
  },
  {
    label: 'IS DO AFTER SUCCESS',
    value: 'isAfterSuccess',
    showField: false,
    isActionOnClick: true,
  },
  {
    label: 'IS ACTIVE',
    value: 'isActive',
    showField: false,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS ACTIVE TAB',
    value: 'isActiveTab',
    showField: false,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS SHOW',
    value: 'isShow',
    showField: false,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS CONDITION',
    value: 'isCondition',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS LOCKED',
    value: 'isLocked',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS COMPARE OPTION',
    value: 'isCompareOption',
    showField: false,
    isDisabledOnFixed: true,
  },
  {
    label: 'IS SELECT ROW',
    value: 'isSelectRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS UN SELECT ROW',
    value: 'isUnSelectRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS BEFORE ADD ROW',
    value: 'isAddRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS BEFORE EDIT ROW',
    value: 'isEditRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS AFTER ADD ROW',
    value: 'isAfterAddRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS AFTER EDIT ROW',
    value: 'isAfterEditRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS AFTER DELETE ROW',
    value: 'isAfterDeleteRow',
    showField: false,
    isCondition: true,
  },
  {
    label: 'IS CHECK LENGTH',
    value: 'isCheckLength',
    showField: true,
    showLength: true,
  },
  {
    label: 'IS SELECT FAVORITE',
    value: 'isSelectFavorite',
    showField: false,
    isCondition: true,
  },
]

export const OPTIONS_PATIENT_PROVIDER = {
  Patient: [
    {
      label: 'IS LOCKED PATIENT',
      value: 'isLocked',
      showField: false,
      isCondition: true,
    },
    {
      label: 'IS LOCKED FINANCE',
      value: 'isLockedFinance',
      showField: false,
      isCondition: true,
    },
    {
      label: 'IS LOCKED MED OPD',
      value: 'isLockedMedOPD',
      showField: false,
      isCondition: true,
    },
  ],
}

export const OPTIONS_ACTION = [
  {
    label: 'SET',
    value: 'isSet',
    showField: true,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'RESET',
    value: 'isReset',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'SHOW',
    value: 'isShow',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'HIDE',
    value: 'isHide',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'SHOW/HIDE LIST',
    value: 'isShowHideList',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'ENABLE',
    value: 'isEnable',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'DISABLE',
    value: 'isDisable',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'REQUIRE',
    value: 'isRequire',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: true,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'WARNING',
    value: 'isWarning',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: true,
  },
  {
    label: 'VALIDATE',
    value: 'isValidate',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'CALL API',
    value: 'callAPI',
    showField: false,
    showElement: false,
    showAPI: true,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'CALL UPSERT TABLE API',
    value: 'callTableAPI',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['table'],
  },
  {
    label: 'CALCULATE',
    value: 'isCalculate',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'CALCULATE DATE',
    value: 'dateToAge',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['date', 'dateTime'],
  },
  {
    label: 'AGE TO DATE',
    value: 'ageToDate',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['input', 'number'],
  },
  {
    label: 'DATE TO TEXT',
    value: 'dateToText',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['date', 'dateTime'],
  },
  {
    label: 'UPDATE CHECKBOX LIST',
    value: 'updateCheckboxList',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['checkboxGroup'],
  },
  {
    label: 'UPDATE DYNAMIC DATA',
    value: 'updateDynamic',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'UPDATE VALUE',
    value: 'updateValue',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'FETCH OPTION',
    value: 'updateOption',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['select', 'autocomplete'],
  },
  {
    label: 'FETCH TABLE',
    value: 'fetchTable',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['table'],
  },
  {
    label: 'FETCH COMPONENT',
    value: 'fetchComponent',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['component'],
  },
  {
    label: 'SELECT ROW TABLE',
    value: 'selectRowTable',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['table'],
  },
  {
    label: 'UNSELECT ROW TABLE',
    value: 'unselectRowTable',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['table'],
  },
  {
    label: 'ACTIVE BUTTON',
    value: 'activeButton',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['button', 'buttonDropdown'],
  },
  {
    label: 'CLICK BUTTON',
    value: 'clickButton',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['button'],
  },
  {
    label: 'ACTIVE TAB',
    value: 'activeTab',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['tabPanel'],
  },
  {
    label: 'CLEAR ACTIVE BUTTON',
    value: 'clearActiveButton',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['button', 'buttonDropdown'],
  },
  {
    label: 'CLEAR ACTIVE TAB',
    value: 'clearActiveTab',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
    specificTag: ['tabPanel'],
  },
  {
    label: 'CLEAR ACTIVE',
    value: 'clearActive',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'COPY',
    value: 'isCopy',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'COLOR LABEL',
    value: 'isColorLabel',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: true,
  },
  {
    label: 'OPEN MODAL',
    value: 'openModal',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'GO TO',
    value: 'goToPrint',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'GO TO URL',
    value: 'goToUrl',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'LOADING',
    value: 'isLoading',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'DONE LOAD',
    value: 'isDoneLoading',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'SYNC DATA',
    value: 'syncData',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'SUCCESS MODAL',
    value: 'successModal',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'RELOAD',
    value: 'isReload',
    showField: false,
    showElement: false,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
  {
    label: 'SHOW LOAD UI',
    value: 'isShowLoadUI',
    showField: false,
    showElement: true,
    showAPI: false,
    showRequire: false,
    showWarning: false,
    showColor: false,
  },
]
